import React from "react";
import * as CHQ from "chq";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type FeedbackSubmittedNotificationProps = {
  notification: CHQ.NotificationFeedbackSubmitted;
  tabIndex?: number;
};

const FeedbackSubmittedNotification: React.FC<FeedbackSubmittedNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => {
  if (actor) {
    return (
      <NotificationBody actor={actor}>
        <ProfileLink user={actor} tabIndex={tabIndex || 0} />
        {" "}
        <Trans>submitted feedback:</Trans>
        {" "}
        {entity.body}
      </NotificationBody>
    );
  }

  return (
    <NotificationBody badge="letter">
      <Trans>A user of CultureHQ has submitted anonymous feedback:</Trans>
      {" "}
      {entity.body}
    </NotificationBody>
  );
};

export default FeedbackSubmittedNotification;
